module.exports = __webpack_public_path__ + "img/phone_black.ea22d484.svg";